module.exports = __webpack_public_path__ + "static/fonts/rajdhani-light-webfont.5883725.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-light-webfont.woff2
// module id = 98
// module chunks = 0